import React, { useState, useEffect, useRef } from "react";
import ReactTooltip from "react-tooltip";
import { ChronosDate } from "../../_helpers";
import { useClickOutside } from "../../_hooks";
// import { v4 as uuid } from "uuid";

//CalendarDatePicker Components
import { CalendarPickerInput, CalendarDatePickerDropdown } from "./";

// const tooltipID = `chronos-datepicker-tooltip`;

export function CalendarDatePicker(props) {
  //Destructure the passed props
  const {
    //Required
    value, //Actual date (string)
    onChange, //Function to handle actual date updates
    calendar, //Calendar system to use
    //Custom Optional
    defaultOpened, //Show the dropdown initially
    defaultStartDate, //Default Date to set if value is null
    defaultNull, //Can the date be null?
    clearable, //Can the user set the date to null?
    //Form Field Options
    placeholder, //Placeholder for "input"
    disabled, //Can the date be changed?
    isDirty, //Is the field value "dirty?"
    tooltipID,
    align = "right",
    showSpacer,
    // onTooltip,
    ...restProps //other props to pass to the field
  } = props;
  //Initialize State for dropdown opened
  const [isDropdownOpen, setDropdownOpen] = useState(defaultOpened);
  const [isFieldDirty, setFieldDirty] = useState(false);
  //Initialize State for date object
  const [date, setDate] = useState(null);
  const datePickerRef = useRef();

  // useClickOutside(datePickerRef, () => {
  //   if (isDropdownOpen) {
  //     setDropdownOpen(false);
  //     if (value !== null) {
  //       const dateStr = new ChronosDate('0', {
  //         calendar,
  //         // logSteps: true,
  //       });
  //       const absoluteDate = dateStr.convertRelativeToAbsolute(date);
  //       // console.warn('Converted Date', { ...absoluteDate }, { ...date });
  //       const dateAsSeconds = dateStr.setDateFromObject(absoluteDate);

  //       // console.warn('Updated Date: ', dateAsSeconds, value);
  //       if (value !== dateAsSeconds) {
  //         setFieldDirty(true);
  //       } else {
  //         setFieldDirty(false);
  //       }
  //     }
  //   }
  // });

  //Function to display/hide the dropdwon
  const toggleDropdown = (setOpened) => {
    const newState = setOpened !== undefined ? setOpened : !isDropdownOpen;
    if (date === null && !isDropdownOpen) {
      const newDate = new ChronosDate(defaultStartDate, {
        calendar,
        logSteps: true,
      });
      // const fullDate = newDate.toFullObject();
      const fullDate = newDate.toRelativeDate();
      console.warn("Default Date", defaultStartDate, newDate, fullDate);

      setDate(fullDate);
    }

    if (newState && datePickerRef.current) {
      // console.log(
      //   `New Dropdown State expanded: ${newState}`,
      //   datePickerRef.current
      // );
      // console.dir(datePickerRef.current);
      try {
        setTimeout(() => {
          datePickerRef.current.scrollIntoView({
            behavior: "smooth",
            // block: 'end',
            inline: "end",
          });
          ReactTooltip.rebuild();
        }, 50);
      } catch (e) {
        console.error(e);
      }
    }
    setDropdownOpen(newState);
    // ReactTooltip.rebuild();
    // //Check if an explicit state is passed
    // if (typeof setOpened === 'boolean') {
    //   //Set explicit state
    //   setDropdownOpen(setOpened);
    // } else {
    //   //No explicit state, just toggle
    //   setDropdownOpen(!isDropdownOpen);
    // }
  };

  //Function to clear the date and set the value to null
  const clearDate = (ev) => {
    // toggleDropdown(false);
    setDropdownOpen(false);
    if (clearable) setDate(null);
    if (onChange) onChange(null);
    ev.preventDefault();
    ev.stopPropagation();
    // ev.stopImmediatePropagation();
    // ReactTooltip.rebuild();
  };

  const handleDateUpdate = (dateChange) => {
    //process new date
    if (date !== null) {
      const newDate = { ...date, ...dateChange };
      // console.log('Updating Date', newDate);
      setDate(newDate);
    }
    // ReactTooltip.rebuild();
    //if updateOnChange, run onChange(newDate)
  };

  //Effect: Value change
  // useEffect(() => {
  //   // if (value && value !== null) {
  //   //   console.log('Calculating changed date: ', value);
  //   //   const newDate = new ChronosDate(value, { calendar }).toFullObject();
  //   //   console.log('Date Value Changed. New Object: ', newDate);
  //   //   setDate(newDate);
  //   // }
  // }, [value]);

  const confirmDate = () => {
    // console.log('Need to actually update this!');
    // console.log('Value', value);
    // console.log('Date', date);
    //Get string value of date
    const dateStr = new ChronosDate("0", {
      calendar,
      logSteps: true,
    });
    const absoluteDate = dateStr.convertRelativeToAbsolute(date);
    // console.warn('Converted Date', { ...absoluteDate }, { ...date });
    const dateAsSeconds = dateStr.setDateFromObject(absoluteDate);

    // console.warn('Updated Date: ', dateAsSeconds);
    // return;
    onChange(dateAsSeconds);
    toggleDropdown(false);
    // ReactTooltip.rebuild();
    // setFieldDirty(false);
  };

  useEffect(() => {
    if (value && value !== null) {
      // console.log('Initial Date', value);
      const startDate = new ChronosDate(value, {
        calendar,
        // logSteps: true,
      })
        // .toFullObject();
        .toRelativeDate();
      // console.log('Setting Initial Date: ', { ...startDate });
      setDate(startDate);
    }
    ReactTooltip.rebuild();
  }, [value]);

  // console.warn('Current Date Value', value, date, calendar);
  let classnames = ["chronos-calendar-date-picker-component"];
  if (showSpacer) {
    classnames.push("chronos-calendar-datepicker-spacer");
  }
  if (showSpacer && isDropdownOpen) {
    classnames.push("chronos-datepicker-open");
  }
  //Render the CalendarPicker
  return (
    <div className={classnames.join(" ")} ref={datePickerRef} {...restProps}>
      <CalendarPickerInput
        date={date}
        calendar={calendar}
        toggleDropdown={toggleDropdown}
        isDropdownOpen={isDropdownOpen}
        clearDate={clearable ? clearDate : undefined}
        placeholder={placeholder}
        isUnset={isFieldDirty}
      />
      {/* <div onClick={demoChangeDate}>Change</div> */}
      {isDropdownOpen && (
        <CalendarDatePickerDropdown
          date={date}
          calendar={calendar}
          updateDate={handleDateUpdate}
          confirmDate={confirmDate}
          tooltipID={tooltipID}
          align={align}
        />
      )}
      {/* <ReactTooltip id={tooltipID} effect="solid" /> */}
    </div>
  );
}
